module.exports = __webpack_public_path__ + "img/info.efdfc356.png";